import { removeTrailing } from "./utils";
import { PhysicalControlGroupStatus } from '../models/physical-inventory-details';
import { PhysicalInventoryStatus } from './physical-inventory-enums';

export class PhysicalControlGroupEntryBase {
    public controlNumber: string = '';
    public entry: number = 0;
    public name: string = '';
    public serviceCenter: string = '';
    public status: PhysicalControlGroupStatus = PhysicalControlGroupStatus.notStarted;
    public reportStatus: PhysicalInventoryStatus = PhysicalInventoryStatus.inProgress
}

export class PhysicalControlGroupEntryPartBase {
    public type: string = '';
    public subtype: string = '';
    public unitOfMeasure: string = '';
    public partNumber: string = '';
    public description: string = '';
}



// for communicating with the server
export class PhysicalControlGroupEntry extends PhysicalControlGroupEntryBase {

    public parts: PhysicalControlGroupEntryPart[] = [];
}

export class PhysicalControlGroupEntryPart extends PhysicalControlGroupEntryPartBase {
    public quantities: (number | null)[] = [];
}

// for use on the horizontal entry screen
export class PhysicalHorizontalEntry extends PhysicalControlGroupEntryBase {
    constructor(base?: PhysicalControlGroupEntry) {
        super();
        if (base) {
            this.controlNumber = base.controlNumber;
            this.entry = base.entry;
            this.name = base.name;
            this.serviceCenter = base.serviceCenter;
            this.status = base.status;
            this.reportStatus = base.reportStatus;
            this.parts = base.parts.map(p => new PhysicalHorizontalEntryPart(p));
        }
    }

    public parts: PhysicalHorizontalEntryPart[] = [];
}

export class PhysicalHorizontalEntryPart extends PhysicalControlGroupEntryPartBase  {

    constructor(base?: PhysicalControlGroupEntryPart) {
        super();
        if (base) {
            this.type = base.type;
            this.subtype = base.subtype;
            this.unitOfMeasure = base.unitOfMeasure;
            this.partNumber = base.partNumber;
            this.description = base.description;
            this.quantity1 = base.quantities[0];
            this.quantity2 = base.quantities[1];
            this.quantity3 = base.quantities[2];
            this.quantity4 = base.quantities[3];
            this.quantity5 = base.quantities[4];
            this.quantity6 = base.quantities[5];
        }
    }

    public isNew: boolean = false;

    public quantity1: any;
    public quantity2: any;
    public quantity3: any;
    public quantity4: any;
    public quantity5: any;
    public quantity6: any;

    public getQuantities(): number[] {
        var result = [
            this.quantity1,
            this.quantity2,
            this.quantity3,
            this.quantity4,
            this.quantity5,
            this.quantity6
        ];

        removeTrailing(result);

        return result;
    }
}

// for use on the vertical entry screen
export class PhysicalVerticalEntry extends PhysicalControlGroupEntryBase {
    constructor(base?: PhysicalControlGroupEntry) {
        super();
        if (base) {
            this.controlNumber = base.controlNumber;
            this.entry = base.entry;
            this.name = base.name;
            this.serviceCenter = base.serviceCenter;
            this.status = base.status;
            this.reportStatus = base.reportStatus;
            this.parts = base.parts.map(p => new PhysicalVerticalEntryPart(p));
        }
    }

    public parts: PhysicalVerticalEntryPart[] = [];
}

export class PhysicalVerticalEntryPart extends PhysicalControlGroupEntryPartBase {
    constructor(base?: PhysicalControlGroupEntryPart) {
        super();
        if (base) {
            this.type = base.type;
            this.subtype = base.subtype;
            this.unitOfMeasure = base.unitOfMeasure;
            this.partNumber = base.partNumber;
            this.description = base.description;

            let i = 0;

            for (i = 0; i < base.quantities.length; i++) {
                if (i % 2 === 0) {
                    this.quantities.push(new VerticalInventoryQuantityRow());
                    this.quantities[i / 2].quantity1 = base.quantities[i];
                }
                else {
                    this.quantities[Math.floor(i / 2)].quantity2 = base.quantities[i];
                }
            }

            // finish out the rows
            for (i = i; i < 12; i++) {
                if (i % 2 === 0) {
                    this.quantities.push(new VerticalInventoryQuantityRow());
                    this.quantities[i / 2].quantity1 = base.quantities[i];
                }
                else {
                    this.quantities[Math.floor(i / 2)].quantity2 = base.quantities[i];
                }
            }
        }
    }

    public quantities: VerticalInventoryQuantityRow[] = [];

    public isNew: boolean = false;

    public getQuantities(): (number | null)[] {

        var result = [] as (number | null)[];
        for(let quantity of this.quantities) {
            result.push(quantity.quantity1);
            result.push(quantity.quantity2);
        }

        removeTrailing(result);

        return result;
    }
}

export class VerticalInventoryQuantityRow {
    public quantity1: any;
    public quantity2: any;
}